import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import store from 'store2';

/**
 * Adds X-Branch-Id header to all custom NMI WebAPI requests.
 * Required for multi-branch users — single-branch users' JWT already contains the branch.
 */
export const nmiBranchInterceptorFn: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.nmiApiUrl)) {
    return next(req);
  }
  const branchId = store('userBranches');
  if (!branchId) {
    return next(req);
  }
  return next(req.clone({
    setHeaders: { 'X-Branch-Id': branchId.toString() }
  }));
};
